import ActionsForm from '@/shared/mixins/actionsForm'
import CountryRepository from '@/shared/http/repositories/geo/country.js'
import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import TravelReasonRepository from '@/shared/http/repositories/configuration/travelreason.js'
import CityRepository from '@/shared/http/repositories/geo/city'
import StateRepository from '@/shared/http/repositories/geo/state'
import AccessTermTravel from '@/shared/mixins/accessTermTravel'
import formData from '../InfoModalTravel/form-modal'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '../../../finance/expenses/travelrefund/mixins/ExpenseMixin.js'

export default {
  name: 'PanelTravel',
  mixins: [ExpenseMixin, ActionsForm, AccessTermTravel],
  components: {AutocompleteZ},
  data () {
    return {
      carregaTable: false,
      dataSituacao: [],
      despesa: [],
      colorSituacao: true,
      DespesasemAdiantamento: false,
      flverificarItens: true,
      tabs: 0,
      dataTravel: [],
      dataStateFim: [],
      dataCityFim: [],
      dataCityOrigem: [],
      dataCountry: [],
      editacao: null,
      form: formData(),
      solicitanteEdicao: false,
      nomeResponsavel: false,
      codigoResponsavel: false,
      BuscaCodigo: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      BuscaNome: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      }
    }
  },
  mounted () {
    this.getAllTravel()
    this.DespesaById()
    this.getAllAccesDes()
    this.semAdiantamento()
    this.getSituacao()
    this.getCountry()
  },
  filters: {
    formatDate (value) {
      let date = new Date(value)
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
    }
  },
  computed: {
    descricaoSituacao: function () {
      this.changeColorSituacao(this.dataDetails.situacao)
      let situacao = this.dataSituacao.find((Element) => parseInt(Element.value) === this.dataDetails.situacao)
      if (situacao !== undefined) return situacao.text
      return 'N/D'
    },
    isFired () {
      return this.dataDetails.demissao ? 'result-info-red' : 'result-info'
    }
  },
  props: {
    comission: {
      type: Boolean,
      default: false
    },
    Situacao: {
      type: Boolean,
      default: false
    },
    dataDetails: {
      type: Object
    },
    tab: {
      type: Number,
      default: 0
    }
  },
  watch: {
    tab (value) {
      this.tabs = value
    },
    Situacao (value) {
      if (value === true) {
        this.GetSituacaoDespesaId()
      }
    },
    'BuscaCodigo.value': function (value) {
      if (value != null) {
        this.codigoResponsavel = true
        this.form.responsavelId.value = this.BuscaCodigo.value
      } else {
        this.codigoResponsavel = false
      }
    },
    'BuscaNome.value': function (value) {
      if (value != null) {
        this.nomeResponsavel = true
        this.form.responsavelId.value = this.BuscaNome.value
      } else {
        this.nomeResponsavel = false
      }
    }
  },
  methods: {
    editarSolitante () {
      this.solicitanteEdicao = !this.solicitanteEdicao
    },
    EditarTermo () {
      loading.push()
      ExpenseRepository.EditaDespesa({CidadeOrigemId: this.despesa.cidadeOrigemId, CidadeDestinoId: this.despesa.cidadeDestinoId, MotivoViagemId: this.despesa.motivoViagemId, DataInicio: this.despesa.inicio, DataFim: this.despesa.fim, DespesaId: this.dataDetails.id, ResponsavelId: this.form.responsavelId.value})
        .then(Response => {
          this.editacao = Response.data
          this.carregaTable = !this.carregaTable
          this.DespesaById()
          this.solicitanteEdicao = false
          this.$emit('reloadTable')
          toast.success('Prestação editada com sucesso!')
          this.fecharPopUp()
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          this.$refs['edita-viagem-term'].hide()
          this.codigoResponsavel = false
          this.nomeResponsavel = false
          this.DespesaById()
          if (Error.response.data != null) {
            toast.warning(Error.response.data)
          } else {
            toast.error('Erro')
          }
          this.$refs['edita-viagem-term'].hide()
          loading.pop()
        })
    },
    fecharPopUp () {
      this.form.estadoOrigemID.value = null
      this.form.cidadeOrigemId.value = null
      this.form.estadoDestinoID.value = null
      this.form.cidadeDestinoId.value = null
      this.form.dataInicio.value = null
      this.form.dataFim.value = null
      this.solicitanteEdicao = false
      this.form.motivoViagemId.value = null
      this.$refs['edita-viagem-prest'].hide()
    },
    getAllTravel () {
      loading.push()
      TravelReasonRepository.GetAllByDesligado(true)
        .then(Response => {
          this.dataTravel = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getCountry () {
      CountryRepository.GetAll()
        .then(Response => {
          this.dataCountry = Response.data.data
          if (this.dataCountry.length <= 1) {
            this.pais = this.dataCountry[0].id
            this.getEstateFim(this.pais)
            this.form.paisDestinoID.value = this.dataCountry[0].id
            this.getEstate(this.pais)
          }
        })
        .catch(Error => console.log(Error))
    },
    getEstateFim (id) {
      loading.push()
      StateRepository.GetAllByCountryID(id)
        .then(Response => {
          this.dataStateFim = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getEstate (id) {
      loading.push()
      StateRepository.GetAllByCountryID(id)
        .then(Response => {
          loading.pop()
          this.dataState = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    onChangeCountryEnd (e) {
      this.getEstate(e)
    },
    onChangeStateOrigem (e) {
      this.getCityOrigem(e)
    },
    onChangeStateFim (e) {
      this.getCityFim(e)
    },
    StateOrigem () {
      this.getCityOrigem(this.despesa.estadoOrigemId)
    },
    StateDestino () {
      this.getCityFim(this.despesa.estadoDestinoID)
    },
    getCityOrigem (id) {
      loading.push()
      CityRepository.GetAllByStateID(id)
        .then(Response => {
          this.dataCityOrigem = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getCityFim (id) {
      loading.push()
      CityRepository.GetAllByStateID(id)
        .then(Response => {
          this.dataCityFim = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    editPrestacao () {
      this.$refs['edita-viagem-prest'].show()
    },
    popUpcoordenadorreprova () {
      this.$refs['reprova-despesa-presta-contas-coordenador'].show()
    },
    popUpcoordenadorreprovaClose () {
      this.$refs['reprova-despesa-presta-contas-coordenador'].hide()
    },
    changeColorSituacao (value) {
      if (parseInt(this.dataDetails.situacao) < 0) {
        this.colorSituacao = false
      } else {
        this.colorSituacao = true
      }
    },
    aprovarModal () {
      this.$emit('verificarItens')
      this.$refs['next-status-modal'].show()
    },
    aprovarModalHide () {
      this.$refs['next-status-modal'].hide()
    },
    nextStatusDespesaAproved () {
      if ((this.dataDetails.lote === null || this.dataDetails.lote === 0 || this.dataDetails.lote === undefined) && this.dataDetails.situacao === 3) {
        toast.warning('Despesa sem lote, por favor gerar o lote para prosseguir com a aprovação!')
      } else {
        this.aprovarModalHide()
        loading.push()
        ExpenseRepository.NextStatusDespesaAproved(this.dataDetails.id)
          .then(Response => {
            loading.pop()
            this.DespesaById()
            this.$emit('reloadTable')
            this.dataDetails.situacao = Response.data.situacao
            toast.success('Despesa alterado com sucesso!!')
          })
          .catch(Error => {
            loading.pop()
            toast.error('Não foi possivel alterar a despesa!!')
          })
      }
    },
    nextStatusNoneLote () {
      loading.push()
      ExpenseRepository.NextStatusNoneLote(this.dataDetails.id)
        .then((Response) => {
          loading.pop()
          this.$emit('reloadTable')
          this.editacao = Response.data
          this.carregaTable = !this.carregaTable
          this.closemodalLote()
          this.DespesaById()
          this.dataDetails.situacao = Response.data.situacao
          toast.success('Despesa alterado com sucesso!!')
        })
        .catch((Error) => {
          loading.pop()
          toast.success('Não foi possivel alterado a despesa!!')
        })
    },
    reprovar () {
      loading.push()
      ExpenseRepository.NextStatusDisaprove(this.dataDetails.id)
        .then(Response => {
          this.dataDetails.situacao = Response.data.situacao
          this.$emit('reloadTable')
          this.editacao = Response.data
          this.DespesaById()
          this.carregaTable = !this.carregaTable
          toast.success('Despesa alterado com sucesso!!')
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.success('Não foi possivel alterado a despesa!!')
        })
    },

    verificaAcessoContro () {
      if (this.hasRole(this.roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        this.reprovaPopUp()
      } else {
        if (this.despesa.semAdiantamento === true) {
          this.popUpcoordenadorreprova()
        } else {
          this.reprovar()
        }
      }
    },

    verificaAcessoElaboracao () {
      if (this.hasRole(this.roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        this.reprovarElaboracao()
      } else {
        this.reprovar()
      }
    },

    onChangeCountryFim (e) {
      this.getEstateFim(e)
    },

    verificaAcessoReprovadoDesconto () {
      if (this.hasRole(this.roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        this.reprovarIrParaDesconto()
      } else {
        this.reprovar()
      }
    },

    verificaAcessoInativarAdiPresta () {
      this.reprovarInativaTermoEprestacao()
    },

    reprovarInativaTermoEprestacao () {
      loading.push()
      ExpenseRepository.ReprovaDespesaCoordenadorRegistros(this.dataDetails.id)
        .then(Response => {
          this.dataDetails.situacao = Response.data.situacao
          this.carregaTable = !this.carregaTable
          this.$emit('carregaTable', this.carregaTable)
          this.$emit('reloadTable')
          this.DespesaById()
          this.popUpcoordenadorreprovaClose()
          toast.success('Despesa alterado com sucesso!!')
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.success('Não foi possivel alterado a despesa!!')
        })
    },

    reprovarIrParaDesconto () {
      loading.push()
      ExpenseRepository.AlteraSituacaDespesa(this.dataDetails.id, 1)
        .then(Response => {
          this.dataDetails.situacao = Response.data.situacao
          this.carregaTable = !this.carregaTable
          this.$emit('carregaTable', this.carregaTable)
          this.$emit('reloadTable')
          this.DespesaById()
          this.$refs['reprova-despesa-presta-contas'].hide()
          toast.success('Despesa alterado com sucesso!!')
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.success('Não foi possivel alterado a despesa!!')
        })
    },

    semAdiantamento () {
      loading.push()
      ExpenseRepository.GetByDespesaId(this.dataDetails.id)
        .then(Response => {
          this.DespesasemAdiantamento = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },

    reprovarElaboracao () {
      loading.push()
      ExpenseRepository.AlteraSituacaoDespesaParaElaboracao(this.dataDetails.id)
        .then(Response => {
          this.dataDetails.situacao = Response.data.situacao
          this.$refs['reprova-despesa-presta-contas'].hide()
          this.$emit('carregaTable', this.carregaTable)
          this.$emit('reloadTable')
          toast.success('Despesa alterado com sucesso!!')
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.success('Não foi possivel alterado a despesa!!')
        })
    },
    DespesaById () {
      loading.push()
      ExpenseRepository.DespesaById(this.dataDetails.id)
        .then(Response => {
          this.despesa = Response.data[0]
          this.StateOrigem()
          this.StateDestino()
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.success('Não foi possivel alterado a despesa!!')
        })
    },

    reprovaPopUp () {
      this.$refs['reprova-despesa-presta-contas'].show()
    },

    reprovaPopUpClose () {
      this.$refs['reprova-despesa-presta-contas'].hide()
    },

    excluirTerm () {
      loading.push()
      ExpenseRepository.Delete(this.dataDetails.id)
        .then(Response => {
          loading.pop()
          // JsonReturn responde HTTP 200 sempre; -400 = exclusão recusada pelo back (ZC-80: adiantamento já pago em lote).
          const r = Response.data
          if (!r || r.code !== 200) {
            this.$bvModal.msgBoxOk((r && r.message) || 'Não foi possível excluir a prestação.', { title: 'Prestação não excluída', okVariant: 'danger' })
            return
          }
          window.location.reload()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    getSituacao () {
      ExpenseRepository.GetEnumSituacao()
        .then(Response => {
          this.dataSituacao = Response.data
        })
        .catch(Error => console.log(Error))
    },
    closemodalLote () {
      this.$refs['OpenModalNonelote'].hide()
    },
    changeText () {
      this.isFired = !this.isFired
    },

    GetSituacaoDespesaId () {
      loading.push()
      ExpenseRepository.GetSituacaoDespesaId(this.dataDetails.id)
        .then(Response => {
          this.dataDetails = Response.data[0]
          this.dataDetails.situacao = this.dataDetails.situacao
          // this.descricaoSituacao = this.dataDetails.situacaoFormatada
          toast.success('Despesa alterado com sucesso!!')
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.success('Não foi possivel alterado a despesa!!')
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/PanelTravel/PanelTravel.js